import { Lead } from "./lead";

export class Datipreventivo {
    public id_comodity:number;
    public lead: Lead;
    public datiextra:Array<typedati>;
    public component:any
}

export class typedati{
    public idDato:number;
    public tipodato : number;
    public lstopzione: Array<keyvalue>;
    public descrizione: string;
    public valore:string;

}

export class keyvalue
{
    public value:string;
    public des:string;
    public urlfoto:string;

}


// WEBPACK FOOTER //
// ./src/app/model/datipreventivo.ts